export function dispatchMarketEventRegister(firstname: string, lastname: string, email: string, phoneNumber: string) {
  try {
    window.lintrk('track', { conversion_id: 16513313 });
  } catch (err) {
    console.error("register link", err);
  }
  try {
    window.rdt('track', 'SignUp', {
      firstname,
      lastname,
      email,
      phoneNumber
    });
  } catch (err) {
    console.error("register reddit", err);
  }
  try {
    window.gtag('event', 'conversion', { send_to: 'AW-11370293658/KUhnCN7Q1_4YEJrT460q' });
  } catch (err) {
    console.error("register gtag", err);
  }
  try {
    window.fbq('trackCustom', 'SignUp', {
      firstname,
      lastname,
      email,
      phoneNumber
    });
  } catch (error) {
    console.error("register fbq", error);
  }
}
